export const limits = [5, 10, 25, 100, 500]

export const dificultades = [
  { code: "wordlist", title: "Using a list of words", nivel: "Fácil" },
  { code: "clues", title: "Using a list of clues", nivel: "Media" },
  { code: "imgs", title: "Using images", nivel: "Media" },
  { code: "oneclue", title: "Using only one clue", nivel: "Difícil" },
  { code: "text", title: "Using a text", nivel: "Difícil" },
]

export const tamanos = [8, 10, 12, 15]

export const langs = ["en", "es"]

// alternativas:
// 🇬🇧
// 🇪🇸
